<template>
<div class="iframe-resize-container" :style="{maxWidth}">
  <div class="iframe-content">
    <iframe ref="iframe" :height="targetHeight" :src="attributes.value" frameborder="0" scrolling="no"></iframe>
  </div>
</div>
</template>

<script>
export default {
  props: ['attributes'],
  data () {
    return {
      dwMessages: {}
    }
  },
  computed: {
    maxWidth () {
      const {maxwidth} = this.attributes
      return maxwidth || 'auto'
    },
    id () {
      return /datawrapper.dwcdn.net\/(.*?)\//g.exec(this.attributes.value)[1]
    },
    targetHeight () {
      if (this.dwMessages[this.id]) {
        return this.dwMessages[this.id] + 'px'
      }
      return this.attributes.height
    }
  },
  mounted () {
    window.addEventListener('message', this.onMessage, false)
  },
  beforeDestroy () {
    window.removeEventListener('message', this.onMessage)
  },
  methods: {
    onMessage (a) {
      if (a.data['datawrapper-height']) {
        this.dwMessages = a.data['datawrapper-height']
      }
    }
  }
}
</script>

<style lang="scss">
.iframe-resize-container {
  line-height: 0;

  .iframe-content {
    margin: 0 auto;

    iframe {
      width: 1px;
      min-width: 100%;
    }
  }
}
</style>
